module.exports = __webpack_public_path__ + "fonts/DINPro-CondBoldIta.eae63538.otf";